import { render, staticRenderFns } from "./doorBlackList.vue?vue&type=template&id=48b47e3a&scoped=true"
import script from "./doorBlackList.vue?vue&type=script&lang=ts"
export * from "./doorBlackList.vue?vue&type=script&lang=ts"
import style0 from "./doorBlackList.vue?vue&type=style&index=0&id=48b47e3a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b47e3a",
  null
  
)

export default component.exports